import { render, staticRenderFns } from "./ReferralLink.vue?vue&type=template&id=8c2851ba&scoped=true&"
import script from "./ReferralLink.vue?vue&type=script&lang=js&"
export * from "./ReferralLink.vue?vue&type=script&lang=js&"
import style0 from "./ReferralLink.vue?vue&type=style&index=0&id=8c2851ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2851ba",
  null
  
)

export default component.exports